import {
  Component,
  Host,
  h,
  Element
} from "@stencil/core";

/**
 * @slot - Slot for chips
 */
@Component({
  tag: "stzh-chipgroup",
  styleUrl: "stzh-chipgroup.scss",
  scoped: true
})
export class StzhChipgroup {
  @Element() element: HTMLStzhChipgroupElement;

  render() {
    const classes = {
      "stzh-chipgroup": true
    };

    return (
      <Host>
        <div class={classes}>
          <slot></slot>
        </div>
      </Host>
    );
  }
}
